// eslint-disable-next-line import/no-unresolved,global-require,import/no-webpack-loader-syntax,import/prefer-default-export
export const loadFlickity = require('bundle-loader?lazy&name=flickity!flickity');
